import { render, staticRenderFns } from "./block-other-party-rental-requirement.vue?vue&type=template&id=28dfadbd&scoped=true&"
import script from "./block-other-party-rental-requirement.vue?vue&type=script&lang=js&"
export * from "./block-other-party-rental-requirement.vue?vue&type=script&lang=js&"
import style0 from "./block-other-party-rental-requirement.vue?vue&type=style&index=0&id=28dfadbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dfadbd",
  null
  
)

export default component.exports